'use client';

import React, { Component, ErrorInfo, ReactNode } from 'react';
import StatusCard from '../ui/StatusCard';

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center h-full w-full p-6 text-center">
          <StatusCard
            type="error"
            heading="Something went wrong"
            text={this.state?.error?.message}
          />
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
